"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prettyFormula = void 0;
const excelFormulaParser = __importStar(require("excel-formula-parser"));
const common_1 = require("@finley-technologies/common");
// eslint-disable-next-line consistent-return
const prettyFormulaHelper = (tree, addBraces = false) => {
    const tabLength = 2;
    const spaces = ' '.repeat(tabLength);
    const addSpaces = (subFormula) => subFormula
        .split('\n')
        .map((line) => `${spaces}${line}`)
        .join('\n');
    switch (tree.type) {
        case 'function': {
            // separate arguments by new lines, and add spaces at beginning of new lines
            const args = tree.arguments
                .map((argument) => addSpaces(prettyFormulaHelper(argument)))
                .join(',\n');
            return args.length
                ? `${tree.name}(
${args}
)`
                : `${tree.name}()`;
        }
        case 'cell':
            return tree.key;
        case 'number':
            return String(tree.value);
        case 'text':
            return `"${tree.value}"`;
        case 'logical':
            // special case for true, our library understands TRUE
            return tree.value ? 'TRUE' : 'FALSE';
        case 'binary-expression': {
            // braces are needed around left and right side of
            // 'binary-expression` to ensure that
            // (4+5) * 7 does not translate to 4+5*7
            const left = prettyFormulaHelper(tree.left, true);
            const right = prettyFormulaHelper(tree.right, true);
            const expr = `${left} ${tree.operator} ${right}`;
            return addBraces ? `(${expr})` : expr;
        }
        case 'unary-expression': {
            // example -A
            const expr = `${tree.operator}${prettyFormulaHelper(tree.operand)}`;
            return addBraces ? `(${expr})` : expr;
        }
        default:
            (0, common_1.finleyAssert)(false, `invalid cell type: ${tree.type}`);
    }
};
// returns prettier formatted version of given formula.
const prettyFormula = (formula) => {
    const tree = excelFormulaParser.parse(formula);
    return prettyFormulaHelper(tree);
};
exports.prettyFormula = prettyFormula;
//# sourceMappingURL=prettyFormula.js.map